import React from 'react';
import { MultiGrid } from 'react-virtualized';
import { observer, Observer } from 'mobx-react-lite';

// @observer
// export default class ObservableMultiGrid extends Component {
//     // We transform the given cellRenderer function to always be called inside an observer context.
//     cellRenderer = cellProps => (
//         <Observer key={cellProps.key} style={{}}>
//             {() => this.props.cellRenderer(cellProps)}
//         </Observer>
//     );

//     render() {
//         return <MultiGrid {...this.props} cellRenderer={this.cellRenderer} />;
//     }
// }

export default observer(function ObservableMultiGrid(props: any) {
    const cellRenderer = (cellProps: any) => (
        <Observer key={cellProps.key}>{() => props.cellRenderer(cellProps)}</Observer>
    );

    return <MultiGrid {...props} cellRenderer={cellRenderer} />;
});
